import type { ChangeEvent, FC } from "react";
import { useTranslation } from "react-i18next";
import type { EmbeddingsInputs } from "../../../../../services/api/instances/embeddingsApi/types";
import { useAppSelector } from "../../../../../services/redux/hooks/use-selector";
import { AppIconButton } from "../../../../../shared/components/AppIconButton";
import { AppInputBase } from "../../../../../shared/components/AppInputBase";
import { TrashIcon } from "../../../../../shared/icons/TrashIcon";
import { selectInputValues } from "../../../redux/selectors";
import styles from "./styles.module.css";

interface Props {
	inputValue: EmbeddingsInputs;
	onDelete: (id: string) => void;
	onInputChange: (id: string, event: ChangeEvent<HTMLInputElement>) => void;
}

export const SidebarListItem: FC<Props> = ({
  inputValue,
  onDelete,
  onInputChange,
}) => {
  const inputValues = useAppSelector(selectInputValues);
  const { t } = useTranslation();

  return (
    <li className={styles["item-container"]}>
      <AppInputBase
        small
        rows={undefined}
        placeholder={t("embeddings.enter_values")}
        fullWidth
        value={inputValue.value}
        onChange={(event: ChangeEvent<HTMLInputElement>) => onInputChange(inputValue.id, event)}
      />
      {
        inputValues.length > 3 &&
          <AppIconButton onClick={() => onDelete(inputValue.id)}>
            <TrashIcon/>
          </AppIconButton>
      }
    </li>
  );
};
